export default {
   ...window.UepAppData
}